/*
 * File: dynamic-template.ts
 * File Created: 2024-09-13 09:29:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-14 09:56:09
 * Modified By: Val Liu
 * -----
 */

import { CreateElement } from "vue";
import { Vue, Component, Prop } from "vue-property-decorator";

/// build the "template" dynamically, and render it in place.
@Component
export default class DynamicTemplate extends Vue {
    @Prop({ type: String })
    template?: string;

    render(h: CreateElement) {
        if (this.template) {
            const { render } = Vue.compile(this.template);
            return render.call(this, this.$createElement);
        }
        return null;
    }
}
